/* eslint-disable react/no-array-index-key */
/* eslint-disable no-underscore-dangle */
/* eslint-disable import/no-extraneous-dependencies */
import React, { useEffect, useState } from 'react';
import { Field, Formik, FieldArray, ErrorMessage } from 'formik';
import {
  Button,
  Box,
  CircularProgress,
  Divider,
  Grid,
  FormHelperText,
  // Stack,
  Card,
  CardContent,
  CardActions,
  CardHeader,
  IconButton,
  InputAdornment,
  TextField,
  Typography,
  Chip,
  Tooltip,
  FormControl,
  FormLabel,
  RadioGroup,
  Radio,
  FormControlLabel,
  Autocomplete,
  Stack
} from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import AddOutlinedIcon from '@mui/icons-material/AddOutlined';
import RemoveOutlinedIcon from '@mui/icons-material/RemoveOutlined';
import UploadIcon from '@mui/icons-material/Upload';
import DownloadOutlinedIcon from '@mui/icons-material/DownloadOutlined';
import HelpIcon from '@mui/icons-material/Help';
import HighlightOffOutlinedIcon from '@mui/icons-material/HighlightOffOutlined';
import DatePicker from 'react-datepicker';
import ImageUploading from 'react-images-uploading';
import dateFormat from 'dateformat';
import { useParams, Link, useNavigate } from 'react-router-dom';
import Loader from '../../utils/errorPages/Loader';
import DeptAction from '../../store/actions/DepartmentAction';
import globalAction from '../../store/actions/GlobalAction';
import PaymentAction from '../../store/actions/PaymentAction';
import UomAction from '../../store/actions/UomAction';
import CompanyAction from '../../store/actions/CompanyAction';
import ClientAction from '../../store/actions/ClientAction';
import CurrencyAction from '../../store/actions/CurrencyAction';
// import Logo from '../../assets/images/logo_image.png';
import DecimalNumberField from '../../components/DecimalNumber';
import QuantityNumberField from '../../components/Quantity';
import PendingPaymentRequest from './pendinig_request';
import { ValidatePaymentRequest } from '../../assets/validation';

function PaymentRequestEdit() {
  // const [clientInfo, setClientInfo] = useState([]);
  const [payInfo, setPayInfo] = useState({});
  const [purchaseType, setPurchateType] = useState('');
  const { code } = useParams();
  const [pendingModal, setPendingModal] = useState(false);
  const navigate = useNavigate();
  const [files, setFiles] = React.useState([]);
  const [velanAddress, setVelanAddress] = useState({});
  const [currencySymbol, setCurrencySymbol] = useState('');
  const { activeDeptData } = useSelector((state) => state.department);
  const { addressData } = useSelector((state) => state.global);
  const { paymentMethodData, paymentTypeData, paymentItemData, isLoading, pendingPaymentData } =
    useSelector((state) => state.payment);
  const { activeUom } = useSelector((state) => state.uom);
  const { currencyActiveData } = useSelector((state) => state.currency);
  const { activeCompanyData } = useSelector((state) => state.company);
  const { companyClientData } = useSelector((state) => state.client);
  // const { invoice, total, currency } = pendingPaymentData;

  const dispatch = useDispatch();
  const { REACT_APP_API_URL } = process.env;
  // useEffect(() => {
  //   dispatch(DeptAction.getActiveItem());
  //   dispatch(CurrencyAction.getActiveItem());
  //   dispatch(CompanyAction.getActiveItem());
  //   dispatch(UomAction.getActiveAll());
  //   dispatch(globalAction.getAddress());
  //   dispatch(PaymentAction.getPaymentMethod());
  //   dispatch(PaymentAction.getPaymentType());
  //   dispatch(PaymentAction.getItem(code));
  // }, [dispatch]);

  useEffect(() => {
    // Dispatch actions that are related or can be logically grouped
    dispatch(DeptAction.getActiveItem());
    dispatch(CurrencyAction.getActiveItem());
    dispatch(CompanyAction.getActiveItem());
    // Add more dispatches here if they are related
  }, [dispatch]); // Include other dependencies if needed

  useEffect(() => {
    // Separate useEffect for unrelated or conditional actions
    dispatch(UomAction.getActiveAll());
    dispatch(globalAction.getAddress());
    dispatch(PaymentAction.getPaymentMethod());
    dispatch(PaymentAction.getPaymentType());
    // Add more dispatches here if they are unrelated to the above
  }, [dispatch]); // Include other dependencies if needed

  // For actions that depend on specific variables like 'code'
  useEffect(() => {
    if (code) {
      dispatch(PaymentAction.getItem(code));
    }
    // You can also dispatch getPaymentMethod and getPaymentType here if they depend on 'code'
  }, [dispatch, code]); // Include 'code' in the dependency array

  const calculateAmount = React.useCallback(
    (qtyValue, rateValue, index, childIndex, setFieldValue) => {
      const quantity = parseFloat(qtyValue);
      const rate = parseFloat(rateValue);
      const amount = quantity * rate;
      setFieldValue(`invoice_details.${index}.services.${childIndex}.amount`, amount.toFixed(2));
    }
  );

  useEffect(() => {
    if (paymentItemData) {
      setPayInfo(paymentItemData);
      if (paymentItemData?.company && paymentItemData?.company._id) {
        dispatch(ClientAction.getCompanyClient(paymentItemData?.company._id));
      }
    }
  }, [paymentItemData]);

  useEffect(() => {
    if (paymentItemData && paymentItemData?.purchase_type) {
      setPurchateType(paymentItemData.purchase_type);
    }
    // if (paymentItemData && companyClientData) {
    //   const clientData = companyClientData.find(
    //     (item) => item.email === paymentItemData.client.email
    //   );
    //   setClientInfo(clientData);
    // }

    if (paymentItemData && addressData) {
      const address = addressData.find(
        (item) => item.address_type === paymentItemData?.address?.address_type
      );

      setVelanAddress(address);
    }
  }, [paymentItemData, companyClientData, addressData]);

  // useEffect(() => {
  //   if (clientInfo) {
  //     setPayInfo((prevValues) => ({
  //       ...prevValues,
  //       primary_email: clientInfo?.email || '',
  //       department_id: clientInfo?.departments || []
  //       // invoice_number: invoiceNumberData || ''
  //     }));
  //   }
  // }, [clientInfo]);

  const handleCompanyChanges = (newValue, setFieldValue) => {
    if (newValue && newValue._id) {
      dispatch(ClientAction.getCompanyClient(newValue._id));
    }
    setFieldValue('client_id', null);
    setFieldValue('primary_email', '');
    setFieldValue('department_id', []);
    setFieldValue('currency_id', null);
  };

  const onChange = (fileList) => {
    // console.log(addUpdateIndex);
    // const newData = fileList.map((item) => item.file);
    setFiles(fileList);
  };
  const onErrorChange = (errors) => {
    if (errors) {
      // console.log(errors, 'errors');
      // setFiles([]);
    }
  };

  const addDays = (date, days) => {
    const result = new Date(date);
    result.setDate(result.getDate() + days);
    return result;
  };

  const handleClientChange = (newValue, setFieldValue) => {
    if (newValue) {
      if (newValue?._id) {
        dispatch(PaymentAction.getPendingPayment(newValue._id, setPendingModal));
      }
    }
    const defaultValues = {
      client_id: null,
      primary_email: '',
      department_id: [],
      currency_id: null,
      payment_method_id: [],
      purchase_type: '',
      purchase_value: ''
    };

    const hasContractDate = !!newValue?.contract_date;
    const updatedValues = newValue
      ? {
          client_id: newValue || null,
          primary_email: newValue.email || '',
          department_id: newValue.departments || [],
          currency_id: newValue.currency || null,
          payment_method_id: newValue.payment_method || [],
          purchase_type: hasContractDate ? 'contract_date' : '',
          purchase_value: hasContractDate ? newValue.contract_date : ''
        }
      : defaultValues;
    setPurchateType(hasContractDate ? 'contract_date' : '');
    Object.entries(updatedValues).forEach(([key, value]) => {
      setFieldValue(key, value);
    });
  };

  useEffect(() => {
    if (payInfo && payInfo !== undefined && payInfo !== '') {
      if (payInfo.timeSheet && payInfo.timeSheet !== undefined) {
        const updatedTimeSheets = payInfo.timeSheet.map((item) => {
          const lastUnderscoreIndex = item.time_sheet.lastIndexOf('_');
          const fileName = item.time_sheet.substring(lastUnderscoreIndex + 1);
          return {
            ...item,
            name: fileName
          };
        });
        setFiles(updatedTimeSheets);
      }
    }
  }, [payInfo]);

  const getDirtyValues = (values, initialObject) => {
    const data = { ...values };
    const keyValues = Object.keys(data);

    const dirtyValues = keyValues.filter((keyValue) => data[keyValue] !== initialObject[keyValue]);

    keyValues.forEach((key) => {
      if (!dirtyValues.includes(key)) delete data[key];
    });
    return data;
  };

  const getPreviousMonthRange = () => {
    const now = new Date();
    const startOfPrevMonth = new Date(now.getFullYear(), now.getMonth() - 1, 1);
    const endOfPrevMonth = new Date(now.getFullYear(), now.getMonth(), 0);

    return {
      from: startOfPrevMonth,
      to: endOfPrevMonth
    };
  };

  const { from, to } = getPreviousMonthRange();

  const initialValues = {
    invoice_number: payInfo && payInfo.invoice_number ? payInfo.invoice_number : '',
    office_id: payInfo && payInfo.address ? payInfo.address : null,
    invoice_date: payInfo && payInfo.invoice_date ? payInfo.invoice_date : '',
    currency_id: payInfo && payInfo.currency ? payInfo.currency : null,
    company_id: payInfo && payInfo.company ? payInfo.company : null,
    client_id: payInfo && payInfo.client ? payInfo.client : null,
    client_approval_date:
      payInfo && payInfo.client_approval_date ? payInfo.client_approval_date : '',
    due_date: payInfo && payInfo.due_date ? payInfo.due_date : '',
    primary_email: payInfo && payInfo.primary_email ? payInfo.primary_email : '',
    invoice_email: payInfo && payInfo.invoice_email ? payInfo.invoice_email : [],
    department_id: payInfo && payInfo.departments ? payInfo.departments : [],
    payment_method_id: payInfo && payInfo.paymentMethod ? payInfo.paymentMethod : [],
    purchase_type: payInfo && payInfo.purchase_type ? payInfo.purchase_type : '',
    purchase_value: payInfo && payInfo.purchase_value ? payInfo.purchase_value : '',
    time_sheet: [],
    request_type_id:
      payInfo && payInfo.paymentRequestType && payInfo.paymentRequestType.type
        ? payInfo.paymentRequestType.type
        : '',
    invoice_details:
      payInfo && payInfo.details
        ? payInfo.details
        : [
            {
              services_from: from,
              services_to: to,
              services: [
                {
                  service_description: '',
                  quantity: '',
                  unit_measurement_id: null,
                  rate: '',
                  amount: ''
                }
              ]
            }
          ]
  };

  const handleFileRemove = (id) => {
    dispatch(PaymentAction.deleteTimeSheet(id));
  };

  return (
    <Box sx={{ mb: 3 }} className="cardWrapper requestType">
      <div className="pageTitleWrap">
        <Stack direction="row" spacing={1} alignItems="center">
          <Typography variant="text" component={Link} to="/payment-request">
            Payment Request
          </Typography>
          <Typography component="h2" variant="h2">
            / Edit
          </Typography>
        </Stack>
      </div>
      <Formik
        initialValues={initialValues}
        validationSchema={ValidatePaymentRequest}
        enableReinitialize
        onSubmit={(values, { setErrors, setSubmitting }) => {
          const updateValues = getDirtyValues(values, initialValues);
          const newValues = { ...updateValues };
          if (newValues.department_id && newValues.department_id.length > 0) {
            const departmentIds = newValues.department_id.map((item) => item._id);
            newValues.department_id = departmentIds;
          }
          if (newValues.payment_method_id && newValues.payment_method_id.length > 0) {
            const paymentIds = newValues.payment_method_id.map((item) => item._id);
            newValues.payment_method_id = paymentIds;
          }
          if (newValues.invoice_details && newValues.invoice_details.length > 0) {
            const updatedInvoiceDetails = newValues.invoice_details.map((detail) => ({
              ...detail,
              services_from: dateFormat(detail.services_from, 'yyyy-mm-dd'),
              services_to: dateFormat(detail.services_to, 'yyyy-mm-dd'),
              services: detail.services.map((service) => ({
                ...service,
                unit_measurement_id: service.unit_measurement_id._id
              }))
            }));
            newValues.invoice_details = updatedInvoiceDetails;
          }
          newValues.invoice_date = dateFormat(newValues.invoice_date, 'yyyy-mm-dd');

          if (newValues.office_id) {
            newValues.office_id = values.office_id._id;
          }

          if (newValues.time_sheet) {
            const newData = files.map((item) => item.file);
            if (newData.length > 0) {
              newValues.time_sheet = newData;
            } else {
              delete newValues.time_sheet;
            }
          }
          if (newValues.client_id) {
            newValues.client_id = newValues.client_id._id;
          }

          if (newValues.currency_id) {
            newValues.currency_id = newValues.currency_id._id;
          }

          if (newValues.company_id) {
            newValues.company_id = newValues.company_id._id;
          }
          if (newValues.purchase_value) {
            newValues.purchase_type = purchaseType;
          }

          const selectedItem = paymentTypeData.find((item) => item.type === values.request_type_id);
          const selectedId = selectedItem ? selectedItem._id : '';
          newValues.request_type_id = selectedId;

          dispatch(PaymentAction.update(code, newValues, setErrors, setSubmitting, navigate));
        }}
      >
        {({
          errors,
          touched,
          values,
          handleChange,
          handleBlur,
          handleSubmit,
          handleReset,
          isSubmitting,
          setFieldValue,
          setFieldTouched
        }) => (
          <form onSubmit={handleSubmit} autoComplete="off">
            {isLoading ? <Loader /> : ''}
            <Grid container spacing={2}>
              <Grid item md={12} lg={12}>
                <Card>
                  <CardHeader title="Payment Details" />
                  <CardContent>
                    <Field
                      name="office_id"
                      component={Autocomplete}
                      options={addressData ?? []}
                      isOptionEqualToValue={(option, value) =>
                        option.address_type === value.address_type
                      }
                      value={values.office_id}
                      onChange={(e, newvalue) => {
                        // handleChange(e);
                        setVelanAddress(newvalue);
                        setFieldValue('office_id', newvalue);
                      }}
                      sx={{ width: '400px' }}
                      getOptionLabel={(option) => option.address_type}
                      renderOption={(props, option) => {
                        return (
                          <li {...props} key={option._id}>
                            {option.address_type}
                          </li>
                        );
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          name="office_id"
                          error={touched.office_id && !!errors.office_id}
                          helperText={touched.office_id && errors.office_id}
                          label="Office Name"
                          placeholder="Search Office"
                          variant="outlined"
                          margin="normal"
                          required={false}
                          InputLabelProps={{ required: true }}
                        />
                      )}
                    />
                    <Divider sx={{ pb: 2, mb: 2.5 }} />
                    <Grid container columnSpacing={2}>
                      <Grid item md={4} lg={4}>
                        <Box className="velanAddressInfo">
                          {velanAddress?.logo && (
                            <img
                              src={`${REACT_APP_API_URL}/${velanAddress.logo}`}
                              alt="Velan Logo"
                              width="180"
                              height="45"
                            />
                          )}
                          <Typography className="" component="p" variant="body1">
                            {velanAddress?.full_address}
                          </Typography>
                        </Box>
                      </Grid>
                      <Grid item md={4} lg={4}>
                        <Field
                          name="invoice_number"
                          component={TextField}
                          fullWidth
                          id="invoice_number"
                          label="Invoice Number"
                          variant="outlined"
                          disabled
                          // defaultValue={invoiceNumberData ? invoiceNumberData.toString() : ''}
                          margin="normal"
                          value={values.invoice_number} // Set value prop to values.invoice_number
                          onChange={(e) => {
                            // handleChange(e);
                            setFieldValue('invoice_number', e.target.value);
                          }}
                          InputProps={{
                            readOnly: true
                          }}
                          error={touched.invoice_number && Boolean(errors.invoice_number)}
                          helperText={touched.invoice_number && errors.invoice_number}
                          // other props...
                        />
                      </Grid>
                      <Grid item md={4} lg={4}>
                        <Box className="datepicker">
                          <DatePicker
                            selected={values.invoice_date}
                            name="invoice_date" // Adding the name attribute here
                            dateFormat="dd MMM yyyy"
                            onChange={(date) => {
                              const newDate = dateFormat(date, 'yyyy-mm-dd');
                              setFieldValue('invoice_date', newDate);
                            }}
                            // isClearable
                            customInput={
                              <TextField
                                label="Invoice Date"
                                error={touched.invoice_date && Boolean(errors.invoice_date)}
                                helperText={touched.invoice_date && errors.invoice_date}
                                fullWidth
                                margin="normal"
                                InputProps={{
                                  endAdornment: (
                                    <InputAdornment position="start">
                                      <IconButton
                                        aria-label="toggle password visibility"
                                        edge="end"
                                        disabled
                                        // color="secondary"
                                      >
                                        <CalendarMonthIcon sx={{ color: '#fff' }} />
                                      </IconButton>
                                    </InputAdornment>
                                  )
                                }}
                              />
                            }
                          />
                        </Box>
                      </Grid>
                    </Grid>
                  </CardContent>
                </Card>
              </Grid>
              <Grid item md={12} lg={12}>
                <Card sx={{ mt: 2 }}>
                  <CardHeader title="Billing Details" />
                  <CardContent>
                    <Grid container columnSpacing={2} rowSpacing={2}>
                      <Grid item md={4} lg={4} xl={3}>
                        <Field
                          name="company_id"
                          component={Autocomplete}
                          options={activeCompanyData ?? []}
                          isOptionEqualToValue={(option, value) => option.name === value.name}
                          value={values.company_id}
                          onChange={(e, newvalue) => {
                            // handleChange(e);
                            setFieldValue('company_id', newvalue);
                            handleCompanyChanges(newvalue, setFieldValue);
                          }}
                          // sx={{ width: '400px' }}
                          getOptionLabel={(option) => option.name}
                          renderOption={(props, option) => {
                            return (
                              <li {...props} key={option._id}>
                                {option.name}
                              </li>
                            );
                          }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              name="company_id"
                              error={touched.company_id && !!errors.company_id}
                              helperText={touched.company_id && errors.company_id}
                              label="Company Name"
                              placeholder="Search Company"
                              variant="outlined"
                              margin="normal"
                              required={false}
                              InputLabelProps={{ required: true }}
                              // SelectProps={{
                              //   IconComponent: ExpandMore
                              // }}
                            />
                          )}
                        />
                      </Grid>
                      <Grid item md={4} lg={4} xl={3}>
                        <Field
                          name="client_id"
                          component={Autocomplete}
                          options={companyClientData ?? []}
                          isOptionEqualToValue={(option, value) => option.email === value.email}
                          value={values.client_id}
                          onChange={(e, newvalue) => {
                            // handleChange(e);
                            // setClientInfo(newvalue);
                            setFieldValue('client_id', newvalue);
                            handleClientChange(newvalue, setFieldValue);
                          }}
                          // sx={{ width: '400px' }}
                          getOptionLabel={(option) => option.name}
                          renderOption={(props, option) => {
                            return (
                              <li {...props} key={option._id}>
                                {option.name}
                              </li>
                            );
                          }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              name="client_id"
                              error={touched.client_id && !!errors.client_id}
                              helperText={touched.client_id && errors.client_id}
                              label="Client Name"
                              placeholder="Search Client"
                              variant="outlined"
                              margin="normal"
                              required={false}
                              InputLabelProps={{ required: true }}
                            />
                          )}
                        />
                        {/* {clientInfo ? (
                          <Typography className="" component="p" variant="body1">
                            {clientInfo?.address_1} <br />
                            {clientInfo?.address_2}
                            {clientInfo?.address_2 && <br />}
                            {clientInfo?.city} <br />
                            {`${clientInfo?.state && clientInfo?.state?.name}, ${
                              clientInfo?.country && clientInfo?.country?.name
                            } - ${clientInfo?.postal_code}`}
                          </Typography>
                        ) : (
                          ''
                        )} */}
                      </Grid>
                      <Grid item md={4} lg={4} xl={3}>
                        <TextField
                          fullWidth
                          id="primary_email"
                          name="primary_email"
                          value={values.primary_email}
                          disabled
                          label="Client Primary Email"
                          variant="outlined"
                          margin="normal"
                          onChange={(e) => {
                            handleChange(e);
                            setFieldValue('primary_email', e.target.value);
                          }}
                          error={touched.primary_email && Boolean(errors.primary_email)}
                          helperText={touched.primary_email && errors.primary_email}
                          required={false}
                          InputLabelProps={{ required: true }}
                        />
                      </Grid>
                      <Grid item md={4} lg={6} xl={3} sx={{ position: 'relative' }}>
                        <Tooltip
                          title="The email field accepts multiple inputs. Please enter emails by typing and pressing Enter."
                          arrow
                          placement="bottom-start"
                        >
                          <IconButton
                            sx={{
                              position: 'absolute',
                              top: '-5px',
                              right: 0
                            }}
                            size="small"
                            aria-label="info"
                          >
                            <HelpIcon fontSize="inherit" />
                          </IconButton>
                        </Tooltip>
                        <Field name="invoice_email">
                          {({ field }) => (
                            <Autocomplete
                              {...field}
                              options={[]}
                              multiple
                              value={values.invoice_email}
                              freeSolo
                              limitTags={2}
                              isOptionEqualToValue={(option, value) => option === value}
                              onChange={(e, newvalue) => {
                                // handleChange(e);
                                setFieldValue('invoice_email', newvalue);
                              }}
                              renderTags={(value, getTagProps) =>
                                value.map((option, index) => {
                                  const isInvalidEmail =
                                    errors.invoice_email && errors.invoice_email[index];
                                  return (
                                    <div className="tagsValue" key={index}>
                                      <Tooltip title={isInvalidEmail || option} arrow>
                                        <Chip
                                          size="small"
                                          color={isInvalidEmail ? 'error' : 'secondary'}
                                          variant="outlined"
                                          sx={{ width: '90px !important' }}
                                          label={option}
                                          {...getTagProps({ index })}
                                          onDelete={() => {
                                            const filteredValues = values.invoice_email.filter(
                                              (_, i) => i !== index
                                            );
                                            setFieldValue('invoice_email', filteredValues);
                                          }}
                                        />
                                      </Tooltip>
                                      {isInvalidEmail && (
                                        <FormHelperText error>
                                          {errors.invoice_email[index]}
                                        </FormHelperText>
                                      )}
                                    </div>
                                  );
                                })
                              }
                              getOptionLabel={(option) => option}
                              renderOption={(props, option) => {
                                return (
                                  <li {...props} key={option._id}>
                                    {option}
                                  </li>
                                );
                              }}
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  error={touched.invoice_email && !!errors.invoice_email}
                                  // helperText={touched.invoice_email && errors.invoice_email}
                                  label="Secondary Email"
                                  placeholder="Enter Email"
                                  variant="outlined"
                                  margin="normal"
                                  // required={false}
                                  // InputLabelProps={{ required: true }}
                                />
                              )}
                            />
                          )}
                        </Field>
                      </Grid>
                      <Grid item md={4} lg={6} xl={3}>
                        <Field
                          name="department_id"
                          component={Autocomplete}
                          options={activeDeptData ?? []}
                          multiple
                          limitTags={2}
                          value={values.department_id}
                          isOptionEqualToValue={(option, value) => option.name === value.name}
                          onChange={(e, newvalue) => {
                            // handleChange(e);
                            setFieldValue('department_id', newvalue);
                          }}
                          renderTags={(value, getTagProps) =>
                            value.map((option, index) => {
                              const { key, ...tagProps } = getTagProps({ index });
                              return (
                                // eslint-disable-next-line react/no-array-index-key
                                <div className="tagsValue" key={index}>
                                  <Tooltip title={option.name} arrow>
                                    <Chip
                                      sx={{ maxWidth: '60px !important' }}
                                      size="small"
                                      color="secondary"
                                      variant="outlined"
                                      label={option.name}
                                      {...tagProps}
                                      deleteIcon={<HighlightOffOutlinedIcon />}
                                    />
                                  </Tooltip>
                                </div>
                              );
                            })
                          }
                          // sx={{ width: '400px' }}
                          getOptionLabel={(option) => option.name}
                          renderOption={(props, option) => {
                            return (
                              <li {...props} key={option._id}>
                                {option.name}
                              </li>
                            );
                          }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              name="department_id"
                              error={touched.department_id && !!errors.department_id}
                              helperText={touched.department_id && errors.department_id}
                              label="Department"
                              placeholder="Enter department"
                              variant="outlined"
                              margin="normal"
                              required={false}
                              InputLabelProps={{ required: true }}
                              // SelectProps={{
                              //   IconComponent: ExpandMore
                              // }}
                            />
                          )}
                        />
                      </Grid>
                      <Grid item md={4} lg={4} xl={3}>
                        <Field
                          name="currency_id"
                          component={Autocomplete}
                          options={currencyActiveData ?? []}
                          filterSelectedOptions
                          value={values.currency_id}
                          isOptionEqualToValue={(option, value) => option.name === value.name}
                          onChange={(e, newvalue) => {
                            // handleChange(e);
                            setFieldValue('currency_id', newvalue);
                            if (newvalue && newvalue.short_name) {
                              setCurrencySymbol(newvalue.short_name);
                            }
                          }}
                          // sx={{ width: '400px' }}
                          getOptionLabel={(option) => option.name}
                          renderOption={(props, option) => {
                            return (
                              <li {...props} key={option._id}>
                                {option.name}
                              </li>
                            );
                          }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              name="currency_id"
                              error={touched.currency_id && !!errors.currency_id}
                              helperText={touched.currency_id && errors.currency_id}
                              label="Currency"
                              placeholder="Search Currency"
                              variant="outlined"
                              margin="normal"
                              required={false}
                              InputLabelProps={{ required: true }}
                              // SelectProps={{
                              //   IconComponent: ExpandMore
                              // }}
                            />
                          )}
                        />
                      </Grid>
                      <Grid item md={4} lg={4} xl={3}>
                        <Box className="datepicker">
                          <DatePicker
                            selected={values.client_approval_date}
                            name="client_approval_date" // Adding the name attribute here
                            dateFormat="dd MMM yyyy"
                            maxDate={addDays(new Date(), 0)}
                            onChange={(date) => {
                              const newDate = dateFormat(date, 'yyyy-mm-dd');
                              setFieldValue('client_approval_date', newDate);
                            }}
                            // isClearable
                            customInput={
                              <TextField
                                label="Client Approval Date"
                                error={
                                  touched.client_approval_date &&
                                  Boolean(errors.client_approval_date)
                                }
                                helperText={
                                  touched.client_approval_date && errors.client_approval_date
                                }
                                fullWidth
                                margin="normal"
                                InputProps={{
                                  endAdornment: (
                                    <InputAdornment position="start">
                                      <IconButton
                                        aria-label="toggle password visibility"
                                        edge="end"
                                        disabled
                                        // color="secondary"
                                      >
                                        <CalendarMonthIcon sx={{ color: '#fff' }} />
                                      </IconButton>
                                    </InputAdornment>
                                  )
                                }}
                              />
                            }
                          />
                        </Box>
                      </Grid>
                      <Grid item md={4} lg={4} xl={3}>
                        <Box className="datepicker">
                          <DatePicker
                            selected={values.due_date}
                            name="due_date" // Adding the name attribute here
                            dateFormat="dd MMM yyyy"
                            minDate={addDays(new Date(), 1)}
                            onChange={(date) => {
                              const newDate = dateFormat(date, 'yyyy-mm-dd');
                              setFieldValue('due_date', newDate);
                            }}
                            // isClearable
                            customInput={
                              <TextField
                                label="Due Date"
                                error={touched.due_date && Boolean(errors.due_date)}
                                helperText={touched.due_date && errors.due_date}
                                fullWidth
                                margin="normal"
                                required={false}
                                InputLabelProps={{ required: true }}
                                InputProps={{
                                  endAdornment: (
                                    <InputAdornment position="start">
                                      <IconButton
                                        aria-label="toggle password visibility"
                                        edge="end"
                                        disabled
                                        // color="secondary"
                                      >
                                        <CalendarMonthIcon sx={{ color: '#fff' }} />
                                      </IconButton>
                                    </InputAdornment>
                                  )
                                }}
                              />
                            }
                          />
                        </Box>
                      </Grid>
                      <Grid item md={4} lg={5} xl={3}>
                        <Field
                          name="payment_method_id"
                          component={Autocomplete}
                          multiple
                          limitTags={2}
                          options={paymentMethodData ?? []}
                          isOptionEqualToValue={(option, value) => option.name === value.name}
                          value={values.payment_method_id}
                          onChange={(e, newvalue) => {
                            // handleChange(e);
                            setFieldValue('payment_method_id', newvalue);
                          }}
                          // sx={{ width: '400px' }}
                          filterSelectedOptions
                          getOptionLabel={(option) => option.name}
                          renderTags={(value, getTagProps) =>
                            value.map((option, index) => {
                              const { key, ...tagProps } = getTagProps({ index });
                              return (
                                // eslint-disable-next-line react/no-array-index-key
                                <div className="tagsValue" key={index}>
                                  <Tooltip title={option.name} arrow>
                                    <Chip
                                      size="small"
                                      color="secondary"
                                      variant="outlined"
                                      label={option.name}
                                      {...tagProps}
                                      deleteIcon={<HighlightOffOutlinedIcon />}
                                    />
                                  </Tooltip>
                                </div>
                              );
                            })
                          }
                          renderOption={(props, option) => {
                            return (
                              <li {...props} key={option._id}>
                                {option.name}
                              </li>
                            );
                          }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              name="payment_method_id"
                              error={touched.payment_method_id && !!errors.payment_method_id}
                              helperText={touched.payment_method_id && errors.payment_method_id}
                              label="Accept Payment Via"
                              placeholder="Search Payment"
                              variant="outlined"
                              margin="normal"
                              required={false}
                              InputLabelProps={{ required: true }}
                              // SelectProps={{
                              //   IconComponent: ExpandMore
                              // }}
                            />
                          )}
                        />
                      </Grid>
                      <Grid item md={4} lg={4} xl={3}>
                        <FormControl>
                          <FormLabel id="demo-controlled-radio-buttons-group">
                            Payment Request type
                          </FormLabel>
                          <RadioGroup
                            row
                            aria-labelledby="demo-controlled-radio-buttons-group"
                            name="request_type_id"
                            value={values.request_type_id}
                            // onChange={handleChange}
                            onChange={(e) => {
                              // handleChange(e);
                              setFieldValue('request_type_id', e.target.value);
                            }}
                          >
                            {paymentTypeData &&
                              paymentTypeData.map((item) => {
                                return (
                                  <FormControlLabel
                                    key={item._id}
                                    value={item.type}
                                    control={<Radio />}
                                    label={item.type}
                                    // checked={values?.request_type_id?.type === item.type}
                                  />
                                );
                              })}
                          </RadioGroup>
                        </FormControl>
                        <FormHelperText error>
                          <ErrorMessage name="request_type_id" component="span" />
                        </FormHelperText>
                      </Grid>
                      <Grid item md={4} lg={4} xl={3}>
                        <FormControl>
                          <FormLabel id="demo-controlled-radio-buttons-group">
                            Payment Purchase Type
                          </FormLabel>
                          <RadioGroup
                            row
                            aria-labelledby="demo-controlled-radio-buttons-group"
                            name="purchase_type"
                            value={values.purchase_type}
                            // onChange={handleChange}
                            onChange={(e) => {
                              handleChange(e);
                              setPurchateType(e.target.value);
                              setFieldValue('purchase_type', e.target.value);
                              setFieldValue('purchase_value', '');
                              setFieldTouched('purchase_value', false, false);
                            }}
                          >
                            <FormControlLabel
                              value="po_number"
                              control={<Radio />}
                              label="PO Number"
                            />
                            <FormControlLabel
                              value="contract_date"
                              control={<Radio />}
                              label="Contract Date"
                            />
                          </RadioGroup>
                          {values.purchase_type && (
                            <Button
                              type="button"
                              size="small"
                              color="info"
                              sx={{ alignSelf: 'flex-start', textTransform: 'none', p: 0 }}
                              onClick={() => {
                                setPurchateType('');
                                setFieldValue('purchase_type', '');
                                setFieldValue('purchase_value', '');
                                setFieldTouched('purchase_type', false, false);
                                setFieldTouched('purchase_value', false, false);
                              }}
                            >
                              Clear selection
                            </Button>
                          )}
                        </FormControl>
                        <FormHelperText error>
                          <ErrorMessage name="purchase_type" component="span" />
                        </FormHelperText>
                      </Grid>
                      <Grid item md={4} lg={4} xl={3}>
                        {purchaseType === 'po_number' && (
                          <TextField
                            fullWidth
                            id="purchase_value"
                            name="purchase_value"
                            value={values.purchase_value}
                            label="Purchasae Order Number"
                            variant="outlined"
                            margin="normal"
                            onBlur={handleBlur}
                            onChange={(e) => {
                              handleChange(e);
                              setFieldValue('purchase_value', e.target.value);
                              setFieldValue('purchase_type', purchaseType);
                            }}
                            error={touched.purchase_value && Boolean(errors.purchase_value)}
                            helperText={touched.purchase_value && errors.purchase_value}
                            required={false}
                            InputLabelProps={{ required: true }}
                          />
                        )}
                        {purchaseType === 'contract_date' && (
                          <Box className="datepicker">
                            <DatePicker
                              selected={
                                values.purchase_value ? new Date(values.purchase_value) : null
                              }
                              name="purchase_value" // Adding the name attribute here
                              dateFormat="dd MMM yyyy"
                              maxDate={new Date()}
                              showMonthDropdown
                              showYearDropdown
                              dropdownMode="select"
                              onChange={(date) => {
                                const newDate = dateFormat(date, 'yyyy-mm-dd');
                                setFieldValue('purchase_value', newDate);
                                setFieldValue('purchase_type', purchaseType);
                              }}
                              // isClearable
                              customInput={
                                <TextField
                                  label="Contract Date"
                                  error={touched.purchase_value && Boolean(errors.purchase_value)}
                                  helperText={touched.purchase_value && errors.purchase_value}
                                  fullWidth
                                  margin="normal"
                                  required={false}
                                  InputLabelProps={{ required: true }}
                                  InputProps={{
                                    endAdornment: (
                                      <InputAdornment position="start">
                                        <IconButton
                                          aria-label="toggle password visibility"
                                          edge="end"
                                          disabled
                                          // color="secondary"
                                        >
                                          <CalendarMonthIcon sx={{ color: '#fff' }} />
                                        </IconButton>
                                      </InputAdornment>
                                    )
                                  }}
                                />
                              }
                            />
                          </Box>
                        )}
                      </Grid>
                      <Grid item md={4} lg={3} xl={3}>
                        <ImageUploading
                          multiple
                          value={files}
                          onChange={onChange}
                          onError={onErrorChange}
                          maxFileSize={5242880}
                          maxNumber={5}
                          dataURLKey="data_url"
                          acceptType={['doc', 'docx', 'pdf', 'xlsx']}
                          allowNonImageType
                        >
                          {({
                            imageList,
                            onImageUpload,
                            // onImageRemoveAll,
                            // onImageUpdate,
                            onImageRemove,
                            // isDragging,
                            dragProps,
                            // eslint-disable-next-line no-shadow
                            errors
                          }) => (
                            <div className="upload__image-wrapper">
                              <Card
                                sx={{
                                  mt: 1,
                                  height: '56px',
                                  border: '1px solid rgba(20,20,20,0.2)',
                                  p: 1,
                                  pl: 2
                                }}
                                elevation={0}
                              >
                                <CardContent sx={{ p: '0 !important', height: '100%' }}>
                                  <Box onClick={onImageUpload} {...dragProps}>
                                    <Stack
                                      className="upload__helpText"
                                      sx={{ height: '100%' }}
                                      direction="row"
                                      spacing={2}
                                      justifyContent="space-between"
                                      alignItems="center"
                                    >
                                      <Typography
                                        className="upload_content"
                                        variant="body1"
                                        component="p"
                                      >
                                        Timesheet
                                      </Typography>
                                      <IconButton aria-label="upload">
                                        <UploadIcon />
                                      </IconButton>
                                    </Stack>
                                  </Box>
                                </CardContent>
                              </Card>
                              <FormHelperText>File Formats: Excel, PDF, Docx </FormHelperText>
                              {errors ? (
                                <FormHelperText error>
                                  {errors.acceptType && (
                                    <span>Only .doc, .docx, .pdf and .xlsx format allowed!</span>
                                  )}
                                  {errors.maxFileSize && (
                                    <span>File size should not exceed 5 MB</span>
                                  )}
                                  {errors.maxNumber && (
                                    <span>You cannot upload more than 5 files</span>
                                  )}
                                </FormHelperText>
                              ) : (
                                ''
                              )}
                              <Stack direction="row" spacing={2}>
                                {imageList && imageList.length > 0
                                  ? imageList.map((sheet, index) => {
                                      return (
                                        <Tooltip
                                          key={index}
                                          title={
                                            sheet.file && sheet.file.name
                                              ? sheet.file.name
                                              : sheet.name
                                          }
                                        >
                                          <Chip
                                            key={index}
                                            color="info"
                                            icon={
                                              <Box
                                                component={Link}
                                                to={`${REACT_APP_API_URL}/${sheet.time_sheet}`}
                                                target="_blank"
                                              >
                                                <DownloadOutlinedIcon />
                                              </Box>
                                            }
                                            label={
                                              sheet.file && sheet.file.name
                                                ? sheet.file.name
                                                : sheet.name
                                            }
                                            onDelete={() => {
                                              onImageRemove(index);
                                              handleFileRemove(sheet._id);
                                            }}
                                            deleteIcon={<HighlightOffOutlinedIcon />}
                                          />
                                        </Tooltip>
                                      );
                                    })
                                  : ''}
                              </Stack>
                            </div>
                          )}
                        </ImageUploading>
                      </Grid>
                    </Grid>
                  </CardContent>
                </Card>
              </Grid>
              <Grid item md={12} lg={12}>
                <Card sx={{ mt: 2 }}>
                  <CardHeader title="Inovice Details" />
                  <CardContent>
                    <FieldArray name="invoice_details">
                      {(arrayHelpers) => (
                        <>
                          {values.invoice_details.map((service, index) => (
                            <React.Fragment key={index}>
                              <Grid
                                container
                                key={index}
                                rowSpacing={2}
                                columnSpacing={2}
                                alignItems="center"
                              >
                                <Grid item xs={4} xl={3} className="datepicker">
                                  <DatePicker
                                    selected={service.services_from}
                                    selectsStart
                                    dateFormat="dd MMM yyyy"
                                    startDate={service.services_from}
                                    endDate={service.services_to}
                                    onChange={(date) => {
                                      setFieldValue(`invoice_details.${index}.services_from`, date);
                                      setFieldValue(`invoice_details.${index}.services_to`, null);
                                    }}
                                    customInput={
                                      <TextField
                                        label="Service From"
                                        fullWidth
                                        margin="normal"
                                        error={
                                          touched.invoice_details?.[index]?.services_from &&
                                          Boolean(errors.invoice_details?.[index]?.services_from)
                                        }
                                        helperText={
                                          touched.invoice_details?.[index]?.services_from &&
                                          errors.invoice_details?.[index]?.services_from
                                        }
                                        required={false}
                                        InputLabelProps={{ required: true }}
                                        InputProps={{
                                          endAdornment: (
                                            <InputAdornment position="start">
                                              <IconButton
                                                aria-label="toggle password visibility"
                                                edge="end"
                                                disabled
                                              >
                                                <CalendarMonthIcon sx={{ color: '#fff' }} />
                                              </IconButton>
                                            </InputAdornment>
                                          )
                                        }}
                                      />
                                    }
                                  />
                                </Grid>
                                <Grid item xs={4} xl={3} className="datepicker">
                                  <DatePicker
                                    selected={service.services_to}
                                    selectsEnd
                                    dateFormat="dd MMM yyyy"
                                    startDate={service.services_from}
                                    endDate={service.services_to}
                                    minDate={service.services_from}
                                    onChange={(date) => {
                                      setFieldValue(`invoice_details.${index}.services_to`, date);
                                    }}
                                    customInput={
                                      <TextField
                                        label="Service To"
                                        fullWidth
                                        margin="normal"
                                        error={
                                          touched.invoice_details?.[index]?.services_to &&
                                          Boolean(errors.invoice_details?.[index]?.services_to)
                                        }
                                        helperText={
                                          touched.invoice_details?.[index]?.services_to &&
                                          errors.invoice_details?.[index]?.services_to
                                        }
                                        required={false}
                                        InputLabelProps={{ required: true }}
                                        InputProps={{
                                          endAdornment: (
                                            <InputAdornment position="start">
                                              <IconButton
                                                aria-label="toggle password visibility"
                                                edge="end"
                                                disabled
                                              >
                                                <CalendarMonthIcon sx={{ color: '#fff' }} />
                                              </IconButton>
                                            </InputAdornment>
                                          )
                                        }}
                                      />
                                    }
                                  />
                                </Grid>
                                <Grid item md={1} lg={1} sx={{ textAlign: 'center' }}>
                                  {index > 0 ? (
                                    <IconButton
                                      className="iconAddRemove"
                                      color="secondary"
                                      sx={{ padding: '8px 10px !important' }}
                                      onClick={() => arrayHelpers.remove(index)}
                                    >
                                      <RemoveOutlinedIcon />
                                    </IconButton>
                                  ) : (
                                    <IconButton
                                      className="iconAddRemove"
                                      color="secondary"
                                      type="button"
                                      sx={{ padding: '8px 10px !important' }}
                                      onClick={() =>
                                        arrayHelpers.push({
                                          services_from: from,
                                          services_to: to,
                                          services: [
                                            {
                                              service_description: '',
                                              quantity: '',
                                              unit_measurement_id: null,
                                              rate: '',
                                              amount: ''
                                            }
                                          ]
                                        })
                                      }
                                    >
                                      <AddOutlinedIcon />
                                    </IconButton>
                                  )}
                                </Grid>
                              </Grid>
                              <Card sx={{ my: 2, border: '1px solid rgba(0,0,0,0.3)' }}>
                                <CardContent sx={{ p: '20px !important' }}>
                                  <FieldArray name={`invoice_details.${index}.services`}>
                                    {(childArrayHelpers) => (
                                      <>
                                        {service.services.map((item, childIndex) => {
                                          // console.log(item); // Log each item in the array
                                          return (
                                            <Grid
                                              container
                                              columnSpacing={2}
                                              rowSpacing={1}
                                              key={childIndex}
                                            >
                                              <Grid item md={4} lg={4}>
                                                <Field
                                                  name={`invoice_details.${index}.services.${childIndex}.service_description`}
                                                >
                                                  {({ field }) => (
                                                    <TextField
                                                      {...field}
                                                      label="Description"
                                                      multiline
                                                      rows={2}
                                                      fullWidth
                                                      value={item.service_description}
                                                      margin="normal"
                                                      required={false}
                                                      InputLabelProps={{ required: true }}
                                                      error={
                                                        touched.invoice_details?.[index]
                                                          ?.services?.[childIndex]
                                                          ?.service_description &&
                                                        Boolean(
                                                          errors.invoice_details?.[index]
                                                            ?.services?.[childIndex]
                                                            ?.service_description
                                                        )
                                                      }
                                                      helperText={
                                                        touched.invoice_details?.[index]
                                                          ?.services?.[childIndex]
                                                          ?.service_description &&
                                                        errors.invoice_details?.[index]?.services?.[
                                                          childIndex
                                                        ]?.service_description
                                                      }
                                                    />
                                                  )}
                                                </Field>
                                              </Grid>
                                              <Grid item md={1} lg={1}>
                                                <Field
                                                  name={`invoice_details.${index}.services.${childIndex}.quantity`}
                                                >
                                                  {({ field }) => (
                                                    <TextField
                                                      {...field}
                                                      label="Qty"
                                                      fullWidth
                                                      // type="number"
                                                      // min={1}
                                                      value={item.quantity}
                                                      margin="normal"
                                                      variant="outlined"
                                                      required={false}
                                                      InputLabelProps={{ required: true }}
                                                      InputProps={{
                                                        inputComponent: QuantityNumberField
                                                      }}
                                                      onChange={(event) => {
                                                        field.onChange(event);
                                                        calculateAmount(
                                                          event.target.value,
                                                          values.invoice_details?.[index]
                                                            ?.services?.[childIndex]?.rate,
                                                          index,
                                                          childIndex,
                                                          setFieldValue
                                                        );
                                                      }}
                                                      error={
                                                        touched.invoice_details?.[index]
                                                          ?.services?.[childIndex]?.quantity &&
                                                        Boolean(
                                                          errors.invoice_details?.[index]
                                                            ?.services?.[childIndex]?.quantity
                                                        )
                                                      }
                                                      helperText={
                                                        touched.invoice_details?.[index]
                                                          ?.services?.[childIndex]?.quantity &&
                                                        errors.invoice_details?.[index]?.services?.[
                                                          childIndex
                                                        ]?.quantity
                                                      }
                                                    />
                                                  )}
                                                </Field>
                                              </Grid>
                                              <Grid item md={2} lg={2}>
                                                <Field
                                                  name={`invoice_details.${index}.services.${childIndex}.unit_measurement_id`}
                                                  component={Autocomplete}
                                                  options={activeUom ?? []}
                                                  isOptionEqualToValue={(option, value) =>
                                                    option.name === value.name
                                                  }
                                                  value={item.unit_measurement_id}
                                                  onChange={(e, newvalue) => {
                                                    // handleChange(e);
                                                    setFieldValue(
                                                      `invoice_details.${index}.services.${childIndex}.unit_measurement_id`,
                                                      newvalue
                                                    );
                                                    // if (newvalue && newvalue._id) {
                                                    //   setFieldValue(
                                                    //     `invoice_details.${index}.services.${childIndex}.unit_measurement_id`,
                                                    //     newvalue._id
                                                    //   );
                                                    // }
                                                  }}
                                                  getOptionLabel={(option) => option.name}
                                                  renderOption={(props, option) => {
                                                    return (
                                                      <li {...props} key={option._id}>
                                                        {option.name}
                                                      </li>
                                                    );
                                                  }}
                                                  renderInput={(params) => (
                                                    <TextField
                                                      {...params}
                                                      name={`invoice_details.${index}.services.${childIndex}.unit_measurement_id`}
                                                      error={
                                                        touched.invoice_details?.[index]
                                                          ?.services?.[childIndex]
                                                          ?.unit_measurement_id &&
                                                        Boolean(
                                                          errors.invoice_details?.[index]
                                                            ?.services?.[childIndex]
                                                            ?.unit_measurement_id
                                                        )
                                                      }
                                                      helperText={
                                                        touched.invoice_details?.[index]
                                                          ?.services?.[childIndex]
                                                          ?.unit_measurement_id &&
                                                        errors.invoice_details?.[index]?.services?.[
                                                          childIndex
                                                        ]?.unit_measurement_id
                                                      }
                                                      label="UOM"
                                                      placeholder="Search UOM"
                                                      variant="outlined"
                                                      margin="normal"
                                                      required={false}
                                                      InputLabelProps={{ required: true }}
                                                      // SelectProps={{
                                                      //   IconComponent: ExpandMore
                                                      // }}
                                                    />
                                                  )}
                                                />
                                              </Grid>
                                              <Grid item md={2} lg={2}>
                                                <Field
                                                  name={`invoice_details.${index}.services.${childIndex}.rate`}
                                                >
                                                  {({ field }) => (
                                                    <TextField
                                                      {...field}
                                                      label="Rate"
                                                      fullWidth
                                                      margin="normal"
                                                      variant="outlined"
                                                      value={item.rate}
                                                      required={false}
                                                      InputLabelProps={{ required: true }}
                                                      InputProps={{
                                                        maxLength: 8,
                                                        inputComponent: DecimalNumberField
                                                      }}
                                                      onChange={(event) => {
                                                        field.onChange(event);
                                                        calculateAmount(
                                                          values.invoice_details?.[index]
                                                            ?.services?.[childIndex]?.quantity,
                                                          event.target.value,
                                                          index,
                                                          childIndex,
                                                          setFieldValue
                                                        );
                                                      }}
                                                      error={
                                                        touched.invoice_details?.[index]
                                                          ?.services?.[childIndex]?.rate &&
                                                        Boolean(
                                                          errors.invoice_details?.[index]
                                                            ?.services?.[childIndex]?.rate
                                                        )
                                                      }
                                                      helperText={
                                                        touched.invoice_details?.[index]
                                                          ?.services?.[childIndex]?.rate &&
                                                        errors.invoice_details?.[index]?.services?.[
                                                          childIndex
                                                        ]?.rate
                                                      }
                                                    />
                                                  )}
                                                </Field>
                                              </Grid>
                                              <Grid item md={2} lg={2}>
                                                <Field
                                                  name={`invoice_details.${index}.services.${childIndex}.amount`}
                                                >
                                                  {({ field }) => (
                                                    <TextField
                                                      {...field}
                                                      label="Amount"
                                                      fullWidth
                                                      value={item.amount}
                                                      margin="normal"
                                                      required={false}
                                                      InputLabelProps={{ required: true }}
                                                      onChange={(event) => {
                                                        field.onChange(event);
                                                        // calculateTotalAmount(values);
                                                      }}
                                                      InputProps={{
                                                        readOnly: true,
                                                        inputComponent: DecimalNumberField,
                                                        startAdornment: (
                                                          <InputAdornment position="start">
                                                            {currencySymbol}
                                                          </InputAdornment>
                                                        )
                                                      }}
                                                      error={
                                                        touched.invoice_details?.[index]
                                                          ?.services?.[childIndex]?.amount &&
                                                        Boolean(
                                                          errors.invoice_details?.[index]
                                                            ?.services?.[childIndex]?.amount
                                                        )
                                                      }
                                                      helperText={
                                                        touched.invoice_details?.[index]
                                                          ?.services?.[childIndex]?.amount &&
                                                        errors.invoice_details?.[index]?.services?.[
                                                          childIndex
                                                        ]?.amount
                                                      }
                                                    />
                                                  )}
                                                </Field>
                                              </Grid>
                                              <Grid item md={1} lg={1} sx={{ textAlign: 'center' }}>
                                                {childIndex > 0 ? (
                                                  <IconButton
                                                    className="iconAddRemove"
                                                    color="secondary"
                                                    sx={{ mt: 3, padding: '8px 10px !important' }}
                                                    onClick={() =>
                                                      childArrayHelpers.remove(childIndex)
                                                    }
                                                  >
                                                    <RemoveOutlinedIcon />
                                                  </IconButton>
                                                ) : (
                                                  <IconButton
                                                    className="iconAddRemove"
                                                    color="secondary"
                                                    type="button"
                                                    sx={{ mt: 3, padding: '8px 10px !important' }}
                                                    onClick={() =>
                                                      childArrayHelpers.push({
                                                        service_description: '',
                                                        quantity: '',
                                                        unit_measurement_id: null,
                                                        rate: '',
                                                        amount: ''
                                                      })
                                                    }
                                                  >
                                                    <AddOutlinedIcon />
                                                  </IconButton>
                                                )}
                                              </Grid>
                                            </Grid>
                                          );
                                        })}
                                      </>
                                    )}
                                  </FieldArray>
                                </CardContent>
                              </Card>
                            </React.Fragment>
                          ))}
                        </>
                      )}
                    </FieldArray>
                  </CardContent>
                  {/* <CardActions sx={{ justifyContent: 'center' }}>
                    <Typography component="p" variant="body1">
                      {totalAmount}
                    </Typography>
                  </CardActions> */}
                </Card>
              </Grid>
              <Grid item md={12} lg={12}>
                <Card sx={{ borderRadius: '0px' }}>
                  <CardActions sx={{ justifyContent: 'center', p: 3 }}>
                    <Button
                      type="submit"
                      className="save__btn"
                      variant="contained"
                      color="secondary"
                      // fullWidth
                      disabled={isSubmitting}
                      size="medium"
                    >
                      {isSubmitting ? <CircularProgress size={20} /> : 'Preview'}
                    </Button>
                    <Button
                      type="button"
                      className="cancel__btn"
                      // fullWidth
                      variant="contained"
                      color="primary"
                      size="medium"
                      onClick={() => {
                        navigate(`/payment-request`);
                      }}
                    >
                      Back
                    </Button>
                    <Button
                      type="button"
                      className="cancel__btn"
                      // fullWidth
                      variant="contained"
                      color="info"
                      size="medium"
                      onClick={() => {
                        handleReset();
                      }}
                    >
                      Clear
                    </Button>
                  </CardActions>
                </Card>
              </Grid>
            </Grid>
          </form>
        )}
      </Formik>
      {pendingModal === true && pendingPaymentData && Object.keys(pendingPaymentData).length > 0 ? (
        <PendingPaymentRequest
          openmodal={pendingModal}
          data={pendingPaymentData}
          // currency={currency}
          // total={total}
          onCloseModal={() => setPendingModal(false)}
        />
      ) : (
        ''
      )}
    </Box>
  );
}
export default PaymentRequestEdit;
